// extracted by mini-css-extract-plugin
export default {"hero":"Template_hero__NMTgs","image":"Template_image__CD6nh","content":"Template_content__tHTZb","contentWithHero":"Template_contentWithHero__jwycM"};